import { TextInput } from '@mantine/core';
import { IFormInputSpecDeviceEvidenceField } from 'pages/revisions-module/template-editor/editors/form/types';

/**
 * Preview for a device evidence field input.
 */
export default function DeviceEvidenceFieldInputPreview({ spec }: { spec: IFormInputSpecDeviceEvidenceField }) {
  return <TextInput required={spec.required} readOnly={spec.readOnly} size="sm" />;
}
